import React, { useEffect, useState } from 'react';
import { Box, Typography, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Button, Chip, IconButton, Radio, RadioGroup, FormControlLabel, TextField, Select, MenuItem, InputLabel, FormControl, Divider } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
interface ComplianceCase {
  id: string;
  type: string;
  priority: 'High' | 'Medium' | 'Low';
  daysOpen: number;
  assignedTo: string;
  status: 'Under Investigation' | 'Pending Review' | 'Awaiting Decision' | 'Escalated' | 'Closed';
  created: string;
  transactionId: string;
  amount: string;
  corridor: string;
  partner: string;
  riskScore: number;
  riskFlags: {
    label: string;
    type: 'error' | 'warning';
  }[];
  partnerRisk: 'High' | 'Medium' | 'Low';
  kybStatus: 'Approved' | 'Pending' | 'Rejected';
  onboardDate: string;
  settlementAccount: string;
  similarTxnCount: number;
}
const MOCK_CASES: ComplianceCase[] = [{
  id: 'CASE-OFAC-20250101-001',
  type: 'Sanctions Hit',
  priority: 'High',
  daysOpen: 2,
  assignedTo: 'Amina Hassan (KYC Officer)',
  status: 'Under Investigation',
  created: '2025-01-01 14:24:00 UTC',
  transactionId: 'TXN-20250101-003',
  amount: '$2,500 USD',
  corridor: 'Nigeria-US',
  partner: 'First Bank Nigeria',
  riskScore: 92,
  riskFlags: [{
    label: 'OFAC Match',
    type: 'error'
  }, {
    label: 'High-Value Tx ($2,500 > $1,000 limit)',
    type: 'warning'
  }, {
    label: 'First-Time High-Value',
    type: 'warning'
  }, {
    label: 'Cross-Border (High-Risk Corridor)',
    type: 'error'
  }, {
    label: 'New Partner (Vetted <30 days)',
    type: 'warning'
  }],
  partnerRisk: 'High',
  kybStatus: 'Approved',
  onboardDate: '2024-11-15',
  settlementAccount: '1110-NG-USD',
  similarTxnCount: 2
}, {
  id: 'CASE-AML-20250101-002',
  type: 'Suspicious Pattern',
  priority: 'Medium',
  daysOpen: 5,
  assignedTo: 'Kofi Mensah (Compliance)',
  status: 'Pending Review',
  created: '2024-12-28 09:15:00 UTC',
  transactionId: 'TXN-20241228-042',
  amount: 'GHS 15,000',
  corridor: 'Ghana-UK',
  partner: 'GTBank',
  riskScore: 68,
  riskFlags: [{
    label: 'Velocity Alert',
    type: 'warning'
  }, {
    label: 'Structuring Pattern',
    type: 'warning'
  }],
  partnerRisk: 'Medium',
  kybStatus: 'Approved',
  onboardDate: '2023-05-10',
  settlementAccount: '2220-GH-GBP',
  similarTxnCount: 5
}, {
  id: 'CASE-REMIT-20250101-003',
  type: 'Remittance Velocity',
  priority: 'Low',
  daysOpen: 10,
  assignedTo: 'Fatima Diallo (Risk)',
  status: 'Awaiting Decision',
  created: '2024-12-23 11:30:00 UTC',
  transactionId: 'TXN-20241223-115',
  amount: 'XOF 500,000',
  corridor: 'Senegal-France',
  partner: 'Orange Money',
  riskScore: 45,
  riskFlags: [{
    label: 'High Frequency',
    type: 'warning'
  }],
  partnerRisk: 'Low',
  kybStatus: 'Approved',
  onboardDate: '2022-01-20',
  settlementAccount: '3330-SN-EUR',
  similarTxnCount: 12
}, {
  id: 'CASE-VEL-20250101-004',
  type: 'High-Value Alert',
  priority: 'Medium',
  daysOpen: 1,
  assignedTo: 'Jane Okafor (Ops)',
  status: 'Escalated',
  created: '2025-01-02 08:45:00 UTC',
  transactionId: 'TXN-20250102-012',
  amount: 'NGN 5,000,000',
  corridor: 'Nigeria-UK',
  partner: 'Zenith Bank',
  riskScore: 75,
  riskFlags: [{
    label: 'High-Value Tx',
    type: 'warning'
  }, {
    label: 'Unusual Corridor for Sender',
    type: 'warning'
  }],
  partnerRisk: 'Medium',
  kybStatus: 'Approved',
  onboardDate: '2021-11-05',
  settlementAccount: '4440-NG-GBP',
  similarTxnCount: 0
}, {
  id: 'CASE-PEP-20250101-005',
  type: 'PEP Match',
  priority: 'High',
  daysOpen: 3,
  assignedTo: 'Kwame Asante (Compliance)',
  status: 'Under Investigation',
  created: '2024-12-30 16:20:00 UTC',
  transactionId: 'TXN-20241230-088',
  amount: 'EUR 10,000',
  corridor: 'Ghana-Germany',
  partner: 'Ecobank Ghana',
  riskScore: 88,
  riskFlags: [{
    label: 'PEP List Match',
    type: 'error'
  }, {
    label: 'High-Value Tx',
    type: 'warning'
  }],
  partnerRisk: 'Low',
  kybStatus: 'Approved',
  onboardDate: '2010-01-01',
  settlementAccount: '5550-GH-EUR',
  similarTxnCount: 1
}, {
  id: 'CASE-STR-20250101-006',
  type: 'Structuring Alert',
  priority: 'Medium',
  daysOpen: 7,
  assignedTo: 'Aisha Bello (Risk)',
  status: 'Pending Review',
  created: '2024-12-26 10:10:00 UTC',
  transactionId: 'TXN-20241226-055',
  amount: '$9,900 USD',
  corridor: 'Nigeria-US',
  partner: 'Guaranty Trust Bank',
  riskScore: 72,
  riskFlags: [{
    label: 'Just Below Reporting Threshold',
    type: 'warning'
  }, {
    label: 'Multiple Txns in 24h',
    type: 'warning'
  }],
  partnerRisk: 'Medium',
  kybStatus: 'Approved',
  onboardDate: '2019-08-12',
  settlementAccount: '6660-NG-USD',
  similarTxnCount: 4
}, {
  id: 'CASE-GEO-20250101-007',
  type: 'High-Risk Geo',
  priority: 'Low',
  daysOpen: 14,
  assignedTo: 'Emmanuel Osei (KYC)',
  status: 'Closed',
  created: '2024-12-19 13:40:00 UTC',
  transactionId: 'TXN-20241219-033',
  amount: 'GHS 2,000',
  corridor: 'Ghana-UK',
  partner: 'MTN Mobile Money',
  riskScore: 35,
  riskFlags: [{
    label: 'High-Risk Destination',
    type: 'warning'
  }],
  partnerRisk: 'Low',
  kybStatus: 'Approved',
  onboardDate: '2018-03-22',
  settlementAccount: '7770-GH-GBP',
  similarTxnCount: 20
}, {
  id: 'CASE-DUP-20250101-008',
  type: 'Duplicate Beneficiary',
  priority: 'Low',
  daysOpen: 4,
  assignedTo: 'Mariama Diallo (Ops)',
  status: 'Awaiting Decision',
  created: '2024-12-29 15:05:00 UTC',
  transactionId: 'TXN-20241229-077',
  amount: 'XOF 100,000',
  corridor: 'Senegal-France',
  partner: 'Ecobank Senegal',
  riskScore: 25,
  riskFlags: [{
    label: 'Duplicate Beneficiary Details',
    type: 'warning'
  }],
  partnerRisk: 'Low',
  kybStatus: 'Approved',
  onboardDate: '2010-01-01',
  settlementAccount: '8880-SN-EUR',
  similarTxnCount: 2
}];
const TABS = ['All', 'Pending Review', 'Under Investigation', 'Awaiting Decision', 'Escalated', 'Closed'];
export default function ComplianceCaseManagement({
  onLogout
}: {
  onLogout: () => void;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCases, setSelectedCases] = useState<string[]>([]);
  const [selectedCaseId, setSelectedCaseId] = useState<string | null>(null);
  const [decision, setDecision] = useState<string>('');
  const [notes, setNotes] = useState('');
  const [evidenceTab, setEvidenceTab] = useState(0);
  const [lastUpdated, setLastUpdated] = useState('Just now');
  const userRole = localStorage.getItem('userRole') || 'maker';
  const isChecker = userRole === 'checker';
  useEffect(() => {
    const interval = setInterval(() => {
      setLastUpdated('Just now');
      setTimeout(() => setLastUpdated('1 minute ago'), 60000);
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  const filteredCases = MOCK_CASES.filter(c => {
    if (activeTab === 0) return true;
    return c.status === TABS[activeTab];
  });
  const selectedCase = MOCK_CASES.find(c => c.id === selectedCaseId);
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedCases(filteredCases.map(c => c.id));
    } else {
      setSelectedCases([]);
    }
  };
  const handleSelectCase = (id: string) => {
    setSelectedCases(prev => prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id]);
  };
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'High':
        return '#AE2A19';
      case 'Medium':
        return '#B38600';
      case 'Low':
        return '#D1D5DB';
      default:
        return '#D1D5DB';
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Under Investigation':
        return '#0052CC';
      case 'Pending Review':
      case 'Awaiting Decision':
        return '#B38600';
      case 'Escalated':
        return '#AE2A19';
      case 'Closed':
        return '#6B7280';
      default:
        return '#6B7280';
    }
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    bgcolor: '#F8F9FA'
  }} data-id="element-2732">
      <TopBar onMenuClick={() => setSidebarOpen(!sidebarOpen)} onLogout={onLogout} data-id="element-2733" />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} activePage="compliance-cases" data-id="element-2734" />

      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      mt: 8,
      ml: 0,
      width: {
        sm: `calc(100% - 240px)`
      },
      display: 'flex',
      gap: 3,
      height: 'calc(100vh - 64px)',
      overflow: 'hidden'
    }} data-id="element-2735">
        {/* LEFT PANEL - CASE QUEUE */}
        <Box sx={{
        width: selectedCaseId ? '60%' : '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.3s ease',
        bgcolor: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        overflow: 'hidden'
      }} data-id="element-2736">
          <Box sx={{
          p: 3,
          borderBottom: '1px solid #E5E7EB'
        }} data-id="element-2737">
            <Typography variant="h4" sx={{
            mb: 2,
            color: '#1F2937'
          }} data-id="element-2738">
              Compliance Cases
            </Typography>

            <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }} data-id="element-2739">
              <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)} variant="scrollable" scrollButtons="auto" sx={{
              minHeight: 40,
              '& .MuiTab-root': {
                textTransform: 'none',
                minHeight: 40,
                fontWeight: 500,
                color: '#6B7280',
                '&.Mui-selected': {
                  color: '#0052CC',
                  fontWeight: 700,
                  bgcolor: '#F0F3F7'
                }
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#0052CC'
              }
            }} data-id="element-2740">
                {TABS.map((tab, index) => {
                const count = index === 0 ? MOCK_CASES.length : MOCK_CASES.filter(c => c.status === tab).length;
                return <Tab key={tab} label={<Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }} data-id="element-2742">
                          {tab}
                          <Chip label={count} size="small" sx={{
                    height: 20,
                    fontSize: '12px',
                    bgcolor: activeTab === index ? 'rgba(0, 82, 204, 0.1)' : '#F3F5F7',
                    color: activeTab === index ? '#0052CC' : '#6B7280',
                    fontWeight: 600
                  }} data-id="element-2743" />
                        </Box>} data-id="element-2741" />;
              })}
              </Tabs>
            </Box>

            {selectedCases.length > 1 && <Box sx={{
            mt: 2,
            p: 1.5,
            bgcolor: '#F0F3F7',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }} data-id="element-2744">
                <Typography variant="body2" fontWeight={600} color="#0052CC" data-id="element-2745">
                  You have selected {selectedCases.length} cases
                </Typography>
                <Box sx={{
              flexGrow: 1
            }} data-id="element-2746" />
                <Button size="small" variant="contained" sx={{
              bgcolor: '#0B7923',
              '&:hover': {
                bgcolor: '#07591F'
              }
            }} data-id="element-2747">
                  Approve All
                </Button>
                <Button size="small" variant="contained" sx={{
              bgcolor: '#AE2A19',
              '&:hover': {
                bgcolor: '#8B1D0F'
              }
            }} data-id="element-2748">
                  Reject All
                </Button>
                <Button size="small" variant="contained" color="primary" data-id="element-2749">
                  Escalate All
                </Button>
              </Box>}
          </Box>

          <TableContainer sx={{
          flexGrow: 1,
          overflow: 'auto'
        }} data-id="element-2750">
            <Table stickyHeader size="small" data-id="element-2751">
              <TableHead data-id="element-2752">
                <TableRow data-id="element-2753">
                  <TableCell padding="checkbox" sx={{
                  bgcolor: '#F3F5F7'
                }} data-id="element-2754">
                    <Checkbox checked={selectedCases.length === filteredCases.length && filteredCases.length > 0} indeterminate={selectedCases.length > 0 && selectedCases.length < filteredCases.length} onChange={handleSelectAll} size="small" data-id="element-2755" />
                  </TableCell>
                  <TableCell sx={{
                  bgcolor: '#F3F5F7',
                  color: '#0052CC',
                  fontWeight: 700
                }} data-id="element-2756">
                    Case ID
                  </TableCell>
                  <TableCell sx={{
                  bgcolor: '#F3F5F7',
                  color: '#0052CC',
                  fontWeight: 700
                }} data-id="element-2757">
                    Type
                  </TableCell>
                  <TableCell sx={{
                  bgcolor: '#F3F5F7',
                  color: '#0052CC',
                  fontWeight: 700
                }} data-id="element-2758">
                    Priority
                  </TableCell>
                  <TableCell sx={{
                  bgcolor: '#F3F5F7',
                  color: '#0052CC',
                  fontWeight: 700
                }} data-id="element-2759">
                    Days Open
                  </TableCell>
                  <TableCell sx={{
                  bgcolor: '#F3F5F7',
                  color: '#0052CC',
                  fontWeight: 700
                }} data-id="element-2760">
                    Assigned To
                  </TableCell>
                  <TableCell sx={{
                  bgcolor: '#F3F5F7',
                  color: '#0052CC',
                  fontWeight: 700
                }} data-id="element-2761">
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody data-id="element-2762">
                {filteredCases.map(row => <TableRow key={row.id} hover onClick={() => setSelectedCaseId(row.id)} selected={selectedCaseId === row.id} sx={{
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: '#F9FAFB'
                },
                '&.Mui-selected': {
                  bgcolor: '#F0F3F7'
                },
                '&.Mui-selected:hover': {
                  bgcolor: '#F0F3F7'
                }
              }} data-id="element-2763">
                    <TableCell padding="checkbox" sx={{
                  borderLeft: `3px solid ${getPriorityColor(row.priority)}`
                }} data-id="element-2764">
                      <Checkbox checked={selectedCases.includes(row.id)} onChange={e => {
                    e.stopPropagation();
                    handleSelectCase(row.id);
                  }} size="small" data-id="element-2765" />
                    </TableCell>
                    <TableCell sx={{
                  fontFamily: 'monospace',
                  fontSize: '12px'
                }} data-id="element-2766">
                      {row.id}
                    </TableCell>
                    <TableCell data-id="element-2767">{row.type}</TableCell>
                    <TableCell data-id="element-2768">
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }} data-id="element-2769">
                        <Box sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: getPriorityColor(row.priority)
                    }} data-id="element-2770" />
                        {row.priority}
                      </Box>
                    </TableCell>
                    <TableCell data-id="element-2771">{row.daysOpen}</TableCell>
                    <TableCell data-id="element-2772">{row.assignedTo}</TableCell>
                    <TableCell data-id="element-2773">
                      <Chip label={row.status} size="small" sx={{
                    bgcolor: getStatusColor(row.status),
                    color: '#FFFFFF',
                    fontWeight: 600,
                    fontSize: '11px',
                    height: 20
                  }} data-id="element-2774" />
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{
          p: 2,
          borderTop: '1px solid #E5E7EB',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }} data-id="element-2775">
            <Typography variant="body2" color="#6B7280" data-id="element-2776">
              Showing 1-{filteredCases.length} of {filteredCases.length} cases
            </Typography>
            <Box sx={{
            display: 'flex',
            gap: 1
          }} data-id="element-2777">
              <Button size="small" disabled data-id="element-2778">
                Previous
              </Button>
              <Button size="small" disabled data-id="element-2779">
                Next
              </Button>
            </Box>
          </Box>
        </Box>

        {/* RIGHT PANEL - CASE DETAIL VIEW */}
        {selectedCase && <Box sx={{
        width: '40%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        overflow: 'auto'
      }} data-id="element-2780">
            <Box sx={{
          p: 3
        }} data-id="element-2781">
              {/* TOP SECTION - CASE HEADER */}
              <Box sx={{
            bgcolor: '#F3F5F7',
            p: 2,
            borderRadius: 2,
            border: '1px solid #E5E7EB',
            mb: 3
          }} data-id="element-2782">
                <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mb: 1.5
            }} data-id="element-2783">
                  <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280'
              }} data-id="element-2784">
                    {selectedCase.id}
                  </Typography>
                  <Box sx={{
                display: 'flex',
                gap: 1
              }} data-id="element-2785">
                    <Chip label={selectedCase.type} size="small" sx={{
                  bgcolor: '#AE2A19',
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '11px',
                  height: 20
                }} data-id="element-2786" />
                    <Chip label={selectedCase.status} size="small" sx={{
                  bgcolor: getStatusColor(selectedCase.status),
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '11px',
                  height: 20
                }} data-id="element-2787" />
                  </Box>
                </Box>
                <Box sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 2
            }} data-id="element-2788">
                  <Box data-id="element-2789">
                    <Typography variant="caption" color="#6B7280" display="block" data-id="element-2790">
                      Created
                    </Typography>
                    <Typography variant="body2" data-id="element-2791">
                      {selectedCase.created}
                    </Typography>
                  </Box>
                  <Box data-id="element-2792">
                    <Typography variant="caption" color="#6B7280" display="block" data-id="element-2793">
                      Days Pending
                    </Typography>
                    <Typography variant="body2" color={selectedCase.daysOpen > 7 ? '#B38600' : 'inherit'} data-id="element-2794">
                      {selectedCase.daysOpen} days
                    </Typography>
                  </Box>
                  <Box sx={{
                gridColumn: '1 / -1'
              }} data-id="element-2795">
                    <Typography variant="caption" color="#6B7280" display="block" data-id="element-2796">
                      Assigned To
                    </Typography>
                    <Typography variant="body2" data-id="element-2797">
                      {selectedCase.assignedTo} |{' '}
                      <span style={{
                    color: '#0052CC',
                    cursor: 'pointer'
                  }} data-id="element-2798">
                        Change Assignment
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* MIDDLE SECTION - RISK ANALYSIS */}
              <Box sx={{
            bgcolor: '#F3F5F7',
            p: 2,
            borderRadius: 2,
            border: '1px solid #E5E7EB',
            mb: 3
          }} data-id="element-2799">
                <Typography variant="subtitle1" sx={{
              mb: 2,
              color: '#1F2937'
            }} data-id="element-2800">
                  Risk Score Breakdown
                </Typography>
                <Box sx={{
              display: 'flex',
              gap: 3
            }} data-id="element-2801">
                  <Box sx={{
                width: '50%'
              }} data-id="element-2802">
                    <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mb: 2
                }} data-id="element-2803">
                      <Typography variant="h3" fontWeight={700} color="#1F2937" data-id="element-2804">
                        {selectedCase.riskScore}/100
                      </Typography>
                      <Chip label={selectedCase.riskScore > 80 ? 'HIGH RISK' : selectedCase.riskScore > 50 ? 'MEDIUM RISK' : 'LOW RISK'} size="small" sx={{
                    bgcolor: selectedCase.riskScore > 80 ? '#AE2A19' : selectedCase.riskScore > 50 ? '#B38600' : '#0B7923',
                    color: 'white',
                    fontWeight: 700
                  }} data-id="element-2805" />
                    </Box>
                    {/* Simple horizontal stacked bar for risk breakdown */}
                    <Box sx={{
                  height: 12,
                  display: 'flex',
                  borderRadius: 1,
                  overflow: 'hidden',
                  mb: 1
                }} data-id="element-2806">
                      <Box sx={{
                    width: '45%',
                    bgcolor: '#AE2A19'
                  }} data-id="element-2807" />
                      <Box sx={{
                    width: '35%',
                    bgcolor: '#B38600'
                  }} data-id="element-2808" />
                      <Box sx={{
                    width: '20%',
                    bgcolor: '#FBBF24'
                  }} data-id="element-2809" />
                    </Box>
                    <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: '11px',
                  color: '#6B7280'
                }} data-id="element-2810">
                      <span data-id="element-2811">Txn: 45%</span>
                      <span data-id="element-2812">Partner: 35%</span>
                      <span data-id="element-2813">Corridor: 20%</span>
                    </Box>
                  </Box>
                  <Box sx={{
                width: '50%'
              }} data-id="element-2814">
                    <Typography variant="body2" fontWeight={700} sx={{
                  mb: 1,
                  color: '#1F2937'
                }} data-id="element-2815">
                      Risk Flags
                    </Typography>
                    <Box sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 0.5
                }} data-id="element-2816">
                      {selectedCase.riskFlags.map((flag, i) => <Chip key={i} label={flag.label} size="small" sx={{
                    bgcolor: flag.type === 'error' ? '#AE2A19' : '#B38600',
                    color: 'white',
                    fontSize: '11px',
                    height: 20
                  }} data-id="element-2817" />)}
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* INVESTIGATION SECTION */}
              <Box sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 2,
            mb: 3
          }} data-id="element-2818">
                <Box sx={{
              bgcolor: '#F3F5F7',
              p: 1.5,
              borderRadius: 2,
              border: '1px solid #E5E7EB'
            }} data-id="element-2819">
                  <Typography variant="body2" fontWeight={700} sx={{
                mb: 1,
                color: '#1F2937'
              }} data-id="element-2820">
                    Transaction Details
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 0.5
              }} data-id="element-2821">
                    TX ID:{' '}
                    <span style={{
                  color: '#0052CC',
                  fontFamily: 'monospace'
                }} data-id="element-2822">
                      {selectedCase.transactionId}
                    </span>
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 0.5
              }} data-id="element-2823">
                    Amount: {selectedCase.amount}
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 0.5
              }} data-id="element-2824">
                    Corridor: {selectedCase.corridor}
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 1
              }} data-id="element-2825">
                    Partner: {selectedCase.partner}
                  </Typography>
                  <Typography variant="caption" sx={{
                color: '#0052CC',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }} data-id="element-2826">
                    View Full Transaction
                  </Typography>
                </Box>
                <Box sx={{
              bgcolor: '#F3F5F7',
              p: 1.5,
              borderRadius: 2,
              border: '1px solid #E5E7EB'
            }} data-id="element-2827">
                  <Typography variant="body2" fontWeight={700} sx={{
                mb: 1,
                color: '#1F2937'
              }} data-id="element-2828">
                    Partner Profile
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 0.5
              }} data-id="element-2829">
                    Name:{' '}
                    <span style={{
                  color: '#0052CC'
                }} data-id="element-2830">
                      {selectedCase.partner}
                    </span>
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 0.5
              }} data-id="element-2831">
                    Risk:{' '}
                    <span style={{
                  color: selectedCase.partnerRisk === 'High' ? '#AE2A19' : '#B38600',
                  fontWeight: 600
                }} data-id="element-2832">
                      {selectedCase.partnerRisk}
                    </span>
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 0.5
              }} data-id="element-2833">
                    KYB:{' '}
                    <span style={{
                  color: '#0B7923',
                  fontWeight: 600
                }} data-id="element-2834">
                      {selectedCase.kybStatus}
                    </span>
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 1
              }} data-id="element-2835">
                    Acct: {selectedCase.settlementAccount}
                  </Typography>
                  <Typography variant="caption" sx={{
                color: '#0052CC',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }} data-id="element-2836">
                    View Partner Details
                  </Typography>
                </Box>
                <Box sx={{
              bgcolor: '#F3F5F7',
              p: 1.5,
              borderRadius: 2,
              border: '1px solid #E5E7EB'
            }} data-id="element-2837">
                  <Typography variant="body2" fontWeight={700} sx={{
                mb: 1,
                color: '#1F2937'
              }} data-id="element-2838">
                    Similar Activity
                  </Typography>
                  <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 1
              }} data-id="element-2839">
                    {selectedCase.similarTxnCount} other high-value transactions
                    from this sender in last 90 days
                  </Typography>
                  {selectedCase.similarTxnCount > 0 && <Typography variant="caption" display="block" sx={{
                color: '#374151',
                mb: 1
              }} data-id="element-2840">
                      Last one: 2 days ago
                    </Typography>}
                  <Typography variant="caption" sx={{
                color: '#0052CC',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }} data-id="element-2841">
                    View Similar Txns
                  </Typography>
                </Box>
              </Box>

              {/* DECISION SECTION */}
              <Box sx={{
            bgcolor: '#F3F5F7',
            p: 2.5,
            borderRadius: 2,
            border: '1px solid #E5E7EB',
            mb: 3
          }} data-id="element-2842">
                <Typography variant="subtitle1" sx={{
              mb: 2,
              color: '#1F2937'
            }} data-id="element-2843">
                  Investigation & Decision
                </Typography>
                <FormControl component="fieldset" sx={{
              width: '100%',
              mb: 3
            }} data-id="element-2844">
                  <RadioGroup value={decision} onChange={e => setDecision(e.target.value)} data-id="element-2845">
                    {/* Option 1: Approve */}
                    <Box sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 1,
                  border: decision === 'approve' ? '1px solid #0B7923' : '1px solid transparent',
                  bgcolor: decision === 'approve' ? 'rgba(11, 121, 35, 0.05)' : 'transparent'
                }} data-id="element-2846">
                      <FormControlLabel value="approve" control={<Radio sx={{
                    color: '#D1D5DB',
                    '&.Mui-checked': {
                      color: '#0B7923'
                    }
                  }} data-id="element-2848" />} label={<Box data-id="element-2849">
                            <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-2850">
                              Approve & Allow Transaction
                            </Typography>
                            <Typography variant="caption" color="#6B7280" data-id="element-2851">
                              Release transaction to proceed to next stage
                              (payout processing)
                            </Typography>
                          </Box>} data-id="element-2847" />
                      {decision === 'approve' && <Box sx={{
                    ml: 4,
                    mt: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }} data-id="element-2852">
                          <FormControlLabel control={<Checkbox size="small" data-id="element-2854" />} label={<Typography variant="caption" data-id="element-2855">
                                Whitelist this sender for future transactions
                              </Typography>} data-id="element-2853" />
                          <FormControlLabel control={<Checkbox size="small" data-id="element-2857" />} label={<Typography variant="caption" data-id="element-2858">
                                Update partner risk profile (lower risk)
                              </Typography>} data-id="element-2856" />
                        </Box>}
                    </Box>

                    {/* Option 2: Escalate */}
                    <Box sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 1,
                  border: decision === 'escalate' ? '1px solid #0052CC' : '1px solid transparent',
                  bgcolor: decision === 'escalate' ? 'rgba(0, 82, 204, 0.05)' : 'transparent'
                }} data-id="element-2859">
                      <FormControlLabel value="escalate" control={<Radio sx={{
                    color: '#D1D5DB',
                    '&.Mui-checked': {
                      color: '#0052CC'
                    }
                  }} data-id="element-2861" />} label={<Box data-id="element-2862">
                            <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-2863">
                              Escalate to Senior Reviewer
                            </Typography>
                            <Typography variant="caption" color="#6B7280" data-id="element-2864">
                              Send case to management for additional review
                            </Typography>
                          </Box>} data-id="element-2860" />
                      {decision === 'escalate' && <Box sx={{
                    ml: 4,
                    mt: 1,
                    display: 'flex',
                    gap: 2
                  }} data-id="element-2865">
                          <FormControl size="small" sx={{
                      minWidth: 200,
                      bgcolor: 'white'
                    }} data-id="element-2866">
                            <InputLabel sx={{
                        fontSize: '12px'
                      }} data-id="element-2867">
                              Escalate To
                            </InputLabel>
                            <Select label="Escalate To" sx={{
                        fontSize: '12px'
                      }} data-id="element-2868">
                              <MenuItem value="mgr1" data-id="element-2869">
                                John Doe (Compliance Mgr)
                              </MenuItem>
                              <MenuItem value="mgr2" data-id="element-2870">
                                Sarah Smith (Risk Director)
                              </MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl size="small" sx={{
                      minWidth: 120,
                      bgcolor: 'white'
                    }} data-id="element-2871">
                            <InputLabel sx={{
                        fontSize: '12px'
                      }} data-id="element-2872">
                              Priority
                            </InputLabel>
                            <Select label="Priority" sx={{
                        fontSize: '12px'
                      }} data-id="element-2873">
                              <MenuItem value="normal" data-id="element-2874">Normal</MenuItem>
                              <MenuItem value="urgent" data-id="element-2875">Urgent</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>}
                    </Box>

                    {/* Option 3: Reject */}
                    <Box sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 1,
                  border: decision === 'reject' ? '1px solid #AE2A19' : '1px solid transparent',
                  bgcolor: decision === 'reject' ? 'rgba(174, 42, 25, 0.05)' : 'transparent'
                }} data-id="element-2876">
                      <FormControlLabel value="reject" control={<Radio sx={{
                    color: '#D1D5DB',
                    '&.Mui-checked': {
                      color: '#AE2A19'
                    }
                  }} data-id="element-2878" />} label={<Box data-id="element-2879">
                            <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-2880">
                              Reject & Block Permanently
                            </Typography>
                            <Typography variant="caption" color="#6B7280" data-id="element-2881">
                              Permanently block this transaction and sender
                            </Typography>
                          </Box>} data-id="element-2877" />
                      {decision === 'reject' && <Box sx={{
                    ml: 4,
                    mt: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }} data-id="element-2882">
                          <FormControlLabel control={<Checkbox size="small" data-id="element-2884" />} label={<Typography variant="caption" data-id="element-2885">
                                Add sender to Ecobank internal watchlist
                              </Typography>} data-id="element-2883" />
                          <FormControlLabel control={<Checkbox size="small" data-id="element-2887" />} label={<Typography variant="caption" data-id="element-2888">
                                Flag partner for review
                              </Typography>} data-id="element-2886" />
                          <FormControlLabel control={<Checkbox size="small" data-id="element-2890" />} label={<Typography variant="caption" data-id="element-2891">
                                Generate SAR (Suspicious Activity Report)
                              </Typography>} data-id="element-2889" />
                        </Box>}
                    </Box>
                  </RadioGroup>
                </FormControl>

                <Box data-id="element-2892">
                  <Typography variant="caption" fontWeight={700} color="#6B7280" sx={{
                mb: 0.5,
                display: 'block'
              }} data-id="element-2893">
                    Investigation Notes & Decision Rationale{' '}
                    <span style={{
                  color: '#AE2A19'
                }} data-id="element-2894">
                      *
                    </span>
                  </Typography>
                  <TextField multiline rows={4} fullWidth placeholder="Describe your findings and why you're making this decision (required for audit trail)..." value={notes} onChange={e => setNotes(e.target.value)} sx={{
                bgcolor: '#FFFFFF',
                '& .MuiInputBase-root': {
                  fontFamily: 'monospace',
                  fontSize: '14px'
                }
              }} data-id="element-2895" />
                  <Typography variant="caption" color="#6B7280" sx={{
                display: 'block',
                textAlign: 'right',
                mt: 0.5
              }} data-id="element-2896">
                    {notes.length}/1000
                  </Typography>
                </Box>

                {!isChecker && selectedCase.status === 'Pending Review' && <Box sx={{
              mt: 2,
              p: 1.5,
              bgcolor: '#FFFBEB',
              border: '1px solid #B38600',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }} data-id="element-2897">
                    <Icon icon="lucide:alert-triangle" color="#B38600" width={16} data-id="element-2898" />
                    <Typography variant="caption" color="#92400E" data-id="element-2899">
                      This case has been submitted for checker review. Awaiting
                      approval by Kofi Mensah.
                    </Typography>
                  </Box>}

                {isChecker && <Box sx={{
              mt: 3,
              pt: 3,
              borderTop: '1px solid #E5E7EB'
            }} data-id="element-2900">
                    <Typography variant="body2" fontWeight={700} sx={{
                mb: 1
              }} data-id="element-2901">
                      Checker Approval
                    </Typography>
                    <FormControlLabel control={<Checkbox size="small" sx={{
                '&.Mui-checked': {
                  color: '#0052CC'
                }
              }} data-id="element-2903" />} label={<Typography variant="caption" data-id="element-2904">
                          I have carefully reviewed all investigation details
                          and concur with the decision above
                        </Typography>} data-id="element-2902" />
                    <Box sx={{
                mt: 2,
                display: 'flex',
                gap: 1
              }} data-id="element-2905">
                      <Button variant="contained" sx={{
                  bgcolor: '#0B7923',
                  '&:hover': {
                    bgcolor: '#07591F'
                  }
                }} data-id="element-2906">
                        Approve Decision
                      </Button>
                      <Button variant="contained" sx={{
                  bgcolor: '#B38600',
                  '&:hover': {
                    bgcolor: '#92400E'
                  }
                }} data-id="element-2907">
                        Request Revision
                      </Button>
                      <Button variant="contained" sx={{
                  bgcolor: '#AE2A19',
                  '&:hover': {
                    bgcolor: '#8B1D0F'
                  }
                }} data-id="element-2908">
                        Reject Decision
                      </Button>
                    </Box>
                  </Box>}
              </Box>

              {/* ACTION BUTTONS */}
              <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mb: 4
          }} data-id="element-2909">
                <Box sx={{
              display: 'flex',
              gap: 1
            }} data-id="element-2910">
                  <Button variant="contained" sx={{
                bgcolor: '#0B7923',
                '&:hover': {
                  bgcolor: '#07591F'
                }
              }} data-id="element-2911">
                    Approve Decision
                  </Button>
                  <Button variant="contained" sx={{
                bgcolor: '#0052CC',
                '&:hover': {
                  bgcolor: '#003DA8'
                }
              }} data-id="element-2912">
                    Escalate to Senior
                  </Button>
                </Box>
                <Box sx={{
              display: 'flex',
              gap: 1
            }} data-id="element-2913">
                  <Button variant="outlined" sx={{
                color: '#6B7280',
                borderColor: '#D1D5DB',
                bgcolor: '#F3F5F7'
              }} data-id="element-2914">
                    Print Case File
                  </Button>
                  <Button variant="contained" sx={{
                bgcolor: '#B38600',
                '&:hover': {
                  bgcolor: '#92400E'
                }
              }} data-id="element-2915">
                    Generate SAR
                  </Button>
                </Box>
              </Box>

              {/* BOTTOM SECTION - AUDIT TRAIL & EVIDENCE */}
              <Box data-id="element-2916">
                <Tabs value={evidenceTab} onChange={(_, newValue) => setEvidenceTab(newValue)} sx={{
              minHeight: 40,
              borderBottom: '1px solid #E5E7EB',
              '& .MuiTab-root': {
                textTransform: 'none',
                minHeight: 40,
                fontWeight: 600,
                color: '#6B7280',
                '&.Mui-selected': {
                  color: '#1F2937'
                }
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#1F2937'
              }
            }} data-id="element-2917">
                  <Tab label="Audit Trail (Immutable)" data-id="element-2918" />
                  <Tab label="Evidence & Supporting Documents" data-id="element-2919" />
                </Tabs>

                <Box sx={{
              bgcolor: '#F3F5F7',
              p: 2,
              borderRadius: '0 0 8px 8px',
              border: '1px solid #E5E7EB',
              borderTop: 'none'
            }} data-id="element-2920">
                  {evidenceTab === 0 && <Box sx={{
                position: 'relative',
                pl: 2
              }} data-id="element-2921">
                      <Box sx={{
                  position: 'absolute',
                  left: 23,
                  top: 10,
                  bottom: 10,
                  width: 2,
                  bgcolor: '#D1D5DB'
                }} data-id="element-2922" />

                      {[{
                  time: '14:24:00',
                  user: 'System',
                  action: 'Auto-blocked transaction due to OFAC hit',
                  type: 'system'
                }, {
                  time: '14:24:15',
                  user: 'System',
                  action: 'Escalated to Compliance Queue (Severity: High)',
                  type: 'system'
                }, {
                  time: '14:25:00',
                  user: 'Amina Hassan (KYC Officer)',
                  action: 'Case assigned to me',
                  type: 'user'
                }, {
                  time: '14:30:00',
                  user: 'Amina Hassan',
                  action: 'Downloaded transaction audit trail from First Bank partner',
                  type: 'user'
                }, {
                  time: '14:35:00',
                  user: 'Amina Hassan',
                  action: 'Reviewed First Bank Nigeria KYB documents (valid through 2025-06-30)',
                  type: 'user'
                }].map((log, i) => <Box key={i} sx={{
                  display: 'flex',
                  mb: 2,
                  position: 'relative',
                  zIndex: 1
                }} data-id="element-2923">
                          <Typography sx={{
                    fontFamily: 'monospace',
                    fontSize: '12px',
                    color: '#6B7280',
                    width: 60,
                    pt: 0.5
                  }} data-id="element-2924">
                            {log.time}
                          </Typography>
                          <Box sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    bgcolor: log.type === 'system' ? '#0B7923' : '#0052CC',
                    mt: 0.8,
                    mx: 1.5,
                    border: '2px solid #F3F5F7'
                  }} data-id="element-2925" />
                          <Box data-id="element-2926">
                            <Typography variant="caption" fontWeight={700} color="#1F2937" display="block" data-id="element-2927">
                              {log.user}
                            </Typography>
                            <Typography variant="body2" color="#374151" data-id="element-2928">
                              {log.action}
                            </Typography>
                          </Box>
                        </Box>)}
                    </Box>}

                  {evidenceTab === 1 && <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2
              }} data-id="element-2929">
                      <Box sx={{
                  bgcolor: '#FFFFFF',
                  p: 2,
                  borderRadius: 1,
                  border: '1px solid #E5E7EB'
                }} data-id="element-2930">
                        <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1
                  }} data-id="element-2931">
                          <Typography variant="body2" fontWeight={700} data-id="element-2932">
                            <Icon icon="lucide:file-text" style={{
                        verticalAlign: 'middle',
                        marginRight: 8
                      }} data-id="element-2933" />
                            Transaction Records
                          </Typography>
                          <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      color: '#0B7923'
                    }} data-id="element-2934">
                            <Icon icon="lucide:check-circle" width={14} data-id="element-2935" />
                            <Typography variant="caption" fontWeight={600} data-id="element-2936">
                              Complete
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="caption" display="block" sx={{
                    mb: 0.5
                  }} data-id="element-2937">
                          • Transaction Receipt (PDF) -{' '}
                          <span style={{
                      color: '#0052CC',
                      cursor: 'pointer'
                    }} data-id="element-2938">
                            Download
                          </span>
                        </Typography>
                        <Typography variant="caption" display="block" sx={{
                    mb: 0.5
                  }} data-id="element-2939">
                          • OFAC Screening Report (PDF) -{' '}
                          <span style={{
                      color: '#0052CC',
                      cursor: 'pointer'
                    }} data-id="element-2940">
                            Download
                          </span>
                        </Typography>
                      </Box>
                      <Box sx={{
                  bgcolor: '#FFFFFF',
                  p: 2,
                  borderRadius: 1,
                  border: '1px solid #E5E7EB'
                }} data-id="element-2941">
                        <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1
                  }} data-id="element-2942">
                          <Typography variant="body2" fontWeight={700} data-id="element-2943">
                            <Icon icon="lucide:user" style={{
                        verticalAlign: 'middle',
                        marginRight: 8
                      }} data-id="element-2944" />
                            First Bank Nigeria - KYB & Screening
                          </Typography>
                          <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      color: '#0B7923'
                    }} data-id="element-2945">
                            <Icon icon="lucide:check-circle" width={14} data-id="element-2946" />
                            <Typography variant="caption" fontWeight={600} data-id="element-2947">
                              Complete
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="caption" display="block" sx={{
                    mb: 0.5
                  }} data-id="element-2948">
                          • Partner KYB Documents (ZIP) -{' '}
                          <span style={{
                      color: '#0052CC',
                      cursor: 'pointer'
                    }} data-id="element-2949">
                            Download
                          </span>
                        </Typography>
                        <Typography variant="caption" display="block" sx={{
                    mb: 0.5
                  }} data-id="element-2950">
                          • Director Screening Results (PDF) -{' '}
                          <span style={{
                      color: '#0052CC',
                      cursor: 'pointer'
                    }} data-id="element-2951">
                            Download
                          </span>
                        </Typography>
                      </Box>
                      <Box sx={{
                  bgcolor: '#FFFFFF',
                  p: 2,
                  borderRadius: 1,
                  border: '1px solid #E5E7EB'
                }} data-id="element-2952">
                        <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1
                  }} data-id="element-2953">
                          <Typography variant="body2" fontWeight={700} data-id="element-2954">
                            <Icon icon="lucide:message-square" style={{
                        verticalAlign: 'middle',
                        marginRight: 8
                      }} data-id="element-2955" />
                            Communication with First Bank Nigeria
                          </Typography>
                          <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      color: '#B38600'
                    }} data-id="element-2956">
                            <Icon icon="lucide:clock" width={14} data-id="element-2957" />
                            <Typography variant="caption" fontWeight={600} data-id="element-2958">
                              Awaiting Response
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="caption" display="block" sx={{
                    mb: 0.5
                  }} data-id="element-2959">
                          • Email: "Additional Info Request" (sent 15:00 to
                          compliance@firstbank.com.ng)
                        </Typography>
                        <Typography variant="caption" display="block" sx={{
                    mb: 0.5
                  }} data-id="element-2960">
                          • Expected response by 2025-01-02 14:00 UTC
                        </Typography>
                      </Box>
                    </Box>}
                </Box>
              </Box>

              <Typography variant="caption" color="#6B7280" sx={{
            display: 'block',
            textAlign: 'center',
            mt: 3
          }} data-id="element-2961">
                (Last updated: {lastUpdated})
              </Typography>
            </Box>
          </Box>}
      </Box>
    </Box>;
}